<template>
  <div class="my-group-buys">
    <!-- 头部 -->
    <header class="page-header">
      <h1>我的团购</h1>
      <p class="subtitle">查看我参与和发起的团购</p>
    </header>

    <!-- 标签切换 -->
    <div class="tabs">
      <div
        v-for="tab in tabs"
        :key="tab.id"
        class="tab"
        :class="{ active: activeTab === tab.id }"
        @click="activeTab = tab.id"
      >
        {{ tab.name }}
      </div>
    </div>

    <!-- 团购列表 -->
    <div class="my-groups-list">
      <div
        v-for="group in filteredGroups"
        :key="group.id"
        class="group-card"
      >
        <div class="card-header">
          <img :src="group.productImage" class="product-image" />
          <div class="product-info">
            <h3 class="product-title">{{ group.productTitle }}</h3>
            <p class="product-spec">{{ group.specification }}</p>
          </div>
        </div>

        <div class="card-body">
          <div class="status-row">
            <span class="status-tag" :class="group.status">{{ group.statusText }}</span>
            <span class="order-time">{{ group.orderTime }}</span>
          </div>

          <div class="price-quantity">
            <span class="price">¥{{ group.price }}</span>
            <span class="quantity">x{{ group.quantity }}</span>
          </div>

          <div class="progress-section">
            <div class="progress-bar">
              <div class="progress" :style="{ width: group.progress + '%' }"></div>
            </div>
            <p class="progress-text">
              已参团 {{ group.joinedCount }}/{{ group.targetCount }}
              <span v-if="group.timeLeft" class="time-left">{{ group.timeLeft }}</span>
            </p>
          </div>

          <!-- 团长信息 -->
          <div class="leader-info" v-if="group.leaderName">
            <img :src="group.leaderAvatar" class="leader-avatar" />
            <span class="leader-name">团长: {{ group.leaderName }}</span>
            <button class="call-btn small" @click="callLeader(group)">
              📞 联系
            </button>
          </div>

          <!-- 商家信息 -->
          <div class="merchant-info">
            <img :src="group.merchantAvatar" class="merchant-avatar" />
            <span class="merchant-name">{{ group.merchantName }}</span>
            <button class="call-btn" @click="callMerchant(group)">
              📞 联系商家
            </button>
          </div>

          <!-- 其他参团成员 -->
          <div class="members-section" v-if="group.members && group.members.length > 0">
            <p class="members-title">参团成员 ({{ group.members.length }}人)</p>
            <div class="members-list">
              <div
                v-for="member in group.members.slice(0, 5)"
                :key="member.id"
                class="member-item"
              >
                <img :src="member.avatar" class="member-avatar" />
                <span class="member-name">{{ member.name }}</span>
                <button class="call-member-btn" @click="callMember(member)">
                  📞
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button class="action-btn secondary" @click="viewDetail(group)">
            查看详情
          </button>
          <button class="action-btn primary" @click="shareGroup(group)">
            邀请好友
          </button>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="filteredGroups.length === 0" class="empty-state">
        <p class="empty-icon">📦</p>
        <p class="empty-text">暂无团购记录</p>
        <button class="go-shopping-btn" @click="goShopping">
          去逛逛
        </button>
      </div>
    </div>

    <!-- 底部导航 -->
    <GroupBuyNav />
  </div>
</template>

<script>
import GroupBuyNav from '@/components/GroupBuyNav.vue';

export default {
  name: 'MyGroupBuys',
  components: {
    GroupBuyNav
  },
  data() {
    return {
      activeTab: 'joined',
      tabs: [
        { id: 'joined', name: '我参与的' },
        { id: 'created', name: '我发起的' },
        { id: 'completed', name: '已完成' }
      ],
      myGroups: [
        {
          id: 1,
          type: 'joined',
          productTitle: '新鲜草莓 现摘现发 5斤装',
          productImage: 'https://images.unsplash.com/photo-1464965911861-746a04b4bca6?w=80&h=80&fit=crop',
          specification: '规格: 5斤装',
          price: 39.9,
          quantity: 1,
          status: 'ongoing',
          statusText: '进行中',
          orderTime: '2024-01-15 10:30',
          joinedCount: 156,
          targetCount: 200,
          progress: 78,
          timeLeft: '还剩2天',
          leaderName: '张三',
          leaderAvatar: 'https://i.pravatar.cc/30?img=10',
          leaderPhone: '13900139001',
          merchantName: '鲜果优选',
          merchantAvatar: 'https://i.pravatar.cc/30?img=1',
          merchantPhone: '13800138001',
          members: [
            { id: 1, name: '李四', avatar: 'https://i.pravatar.cc/30?img=11', phone: '13900139002' },
            { id: 2, name: '王五', avatar: 'https://i.pravatar.cc/30?img=12', phone: '13900139003' },
            { id: 3, name: '赵六', avatar: 'https://i.pravatar.cc/30?img=13', phone: '13900139004' }
          ]
        },
        {
          id: 2,
          type: 'joined',
          productTitle: '进口车厘子 JJ级 2斤装',
          productImage: 'https://images.unsplash.com/photo-1528821128474-27f963b062bf?w=80&h=80&fit=crop',
          specification: '规格: 2斤装',
          price: 89.9,
          quantity: 2,
          status: 'ongoing',
          statusText: '进行中',
          orderTime: '2024-01-14 15:20',
          joinedCount: 89,
          targetCount: 100,
          progress: 89,
          timeLeft: '还剩1天',
          leaderName: '李华',
          leaderAvatar: 'https://i.pravatar.cc/30?img=20',
          leaderPhone: '13900139006',
          merchantName: '环球水果',
          merchantAvatar: 'https://i.pravatar.cc/30?img=2',
          merchantPhone: '13800138002',
          members: [
            { id: 4, name: '小明', avatar: 'https://i.pravatar.cc/30?img=21', phone: '13900139007' },
            { id: 5, name: '小红', avatar: 'https://i.pravatar.cc/30?img=22', phone: '13900139008' }
          ]
        },
        {
          id: 3,
          type: 'created',
          productTitle: '有机蔬菜礼盒 时令搭配',
          productImage: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=80&h=80&fit=crop',
          specification: '规格: 标准装',
          price: 49.9,
          quantity: 1,
          status: 'completed',
          statusText: '已成团',
          orderTime: '2024-01-10 09:00',
          joinedCount: 200,
          targetCount: 200,
          progress: 100,
          timeLeft: null,
          leaderName: '我',
          leaderAvatar: 'https://i.pravatar.cc/30?img=30',
          leaderPhone: '13900139000',
          merchantName: '绿色农场',
          merchantAvatar: 'https://i.pravatar.cc/30?img=3',
          merchantPhone: '13800138003',
          members: [
            { id: 6, name: '用户A', avatar: 'https://i.pravatar.cc/30?img=31', phone: '13900139009' },
            { id: 7, name: '用户B', avatar: 'https://i.pravatar.cc/30?img=32', phone: '13900139010' },
            { id: 8, name: '用户C', avatar: 'https://i.pravatar.cc/30?img=33', phone: '13900139011' },
            { id: 9, name: '用户D', avatar: 'https://i.pravatar.cc/30?img=34', phone: '13900139012' }
          ]
        }
      ]
    };
  },
  computed: {
    filteredGroups() {
      if (this.activeTab === 'completed') {
        return this.myGroups.filter(g => g.status === 'completed');
      }
      return this.myGroups.filter(g => g.type === this.activeTab && g.status !== 'completed');
    }
  },
  methods: {
    callMerchant(group) {
      window.location.href = `tel:${group.merchantPhone}`;
    },
    callLeader(group) {
      window.location.href = `tel:${group.leaderPhone}`;
    },
    callMember(member) {
      window.location.href = `tel:${member.phone}`;
    },
    viewDetail(group) {
      this.$router.push({ name: 'GroupBuyDetail', params: { id: group.id } });
    },
    shareGroup(group) {
      alert(`分享 "${group.productTitle}" 给好友，邀请他们一起参团！`);
    },
    goShopping() {
      this.$router.push({ name: 'GroupBuyHome' });
    }
  }
};
</script>

<style scoped>
.my-group-buys {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 70px;
}

.page-header {
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  color: white;
  padding: 20px;
  text-align: center;
}

.page-header h1 {
  margin: 0;
  font-size: 24px;
}

.subtitle {
  margin: 5px 0 0;
  font-size: 14px;
  opacity: 0.9;
}

.tabs {
  display: flex;
  background: white;
  border-bottom: 1px solid #e0e0e0;
}

.tab {
  flex: 1;
  padding: 15px;
  text-align: center;
  font-size: 15px;
  color: #666;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
}

.tab.active {
  color: #ff6b6b;
  font-weight: bold;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: #ff6b6b;
  border-radius: 2px;
}

.my-groups-list {
  padding: 15px;
}

.group-card {
  background: white;
  border-radius: 12px;
  margin-bottom: 15px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.card-header {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.product-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  margin-right: 15px;
}

.product-info {
  flex: 1;
}

.product-title {
  margin: 0 0 8px;
  font-size: 16px;
  color: #333;
}

.product-spec {
  margin: 0;
  font-size: 13px;
  color: #999;
}

.card-body {
  padding: 15px;
}

.status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.status-tag {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  color: white;
}

.status-tag.ongoing {
  background: #ff6b6b;
}

.status-tag.completed {
  background: #52c41a;
}

.order-time {
  font-size: 12px;
  color: #999;
}

.price-quantity {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.price {
  font-size: 24px;
  font-weight: bold;
  color: #ff6b6b;
}

.quantity {
  font-size: 14px;
  color: #666;
}

.progress-section {
  margin-bottom: 15px;
}

.progress-bar {
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress {
  height: 100%;
  background: linear-gradient(90deg, #ff6b6b, #ee5a6f);
  border-radius: 3px;
}

.progress-text {
  margin: 0;
  font-size: 13px;
  color: #666;
}

.time-left {
  color: #ff6b6b;
  margin-left: 10px;
}

.leader-info,
.merchant-info {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 10px;
}

.leader-avatar,
.merchant-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.leader-name,
.merchant-name {
  flex: 1;
  font-size: 13px;
  color: #666;
}

.call-btn {
  padding: 6px 12px;
  background: #fff0f0;
  border: 1px solid #ff6b6b;
  border-radius: 15px;
  color: #ff6b6b;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.call-btn.small {
  padding: 4px 10px;
  font-size: 11px;
}

.call-btn:hover {
  background: #ff6b6b;
  color: white;
}

.members-section {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.members-title {
  margin: 0 0 10px;
  font-size: 14px;
  color: #333;
}

.members-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.member-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #fafafa;
  border-radius: 20px;
}

.member-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
}

.member-name {
  font-size: 13px;
  color: #666;
  margin-right: 8px;
}

.call-member-btn {
  background: none;
  border: none;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}

.card-footer {
  display: flex;
  gap: 10px;
  padding: 15px;
  border-top: 1px solid #f0f0f0;
}

.action-btn {
  flex: 1;
  padding: 12px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.action-btn.secondary {
  background: white;
  border: 1px solid #e0e0e0;
  color: #666;
}

.action-btn.secondary:hover {
  border-color: #ff6b6b;
  color: #ff6b6b;
}

.action-btn.primary {
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  border: none;
  color: white;
}

.action-btn.primary:hover {
  opacity: 0.9;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 20px;
}

.empty-text {
  font-size: 16px;
  color: #999;
  margin-bottom: 30px;
}

.go-shopping-btn {
  padding: 12px 40px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.go-shopping-btn:hover {
  opacity: 0.9;
}
</style>
